import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import dt, { useIsXLarge } from '../../../shared/theme';
import Wire from './wire';

const Container = styled.div`
  margin-top: 56px;
`;

const WiresContainer = styled.div`
  width: 100% !important;
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
  & > section {
    width: 100%;
  }

  ${props => props.isMedium && `
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 56px;

    & > section {
      width: calc((100% - 26px)/2);
    }

    & > section:not(:last-child) {
      margin-right: 26px;
    }
  `};

  ${props => dt(props).theme.isLarge && `
    margin-bottom: 72px;
  `};

  ${props => dt(props).theme.isXLarge && `

    & > section {
      width: calc((100% - 52px)/3);
    }
  `};
`;

export default function Wires({ wires }) {
  const isMedium = useMediaQuery({ query: '(min-width: 569px)' });
  // eslint-disable-next-line no-nested-ternary
  const wiresInRow = useIsXLarge() ? 3 : isMedium ? 2 : 1;

  return (
    <Container>
      {_.chunk(wires, wiresInRow).map((group, rowIndex) => (
        // eslint-disable-next-line react/no-array-index-key
        <WiresContainer isMedium={isMedium} key={`series-wire-group-${rowIndex}`}>
          {group.map((wire, columnIndex) => (
            <Wire key={`series-wire-${wire.id}`} wire={wire} position={rowIndex * wiresInRow + columnIndex + 1} />
          ))}
        </WiresContainer>
      ))}
    </Container>
  );
}

Wires.propTypes = {
  wires: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    primaryImageUrl: PropTypes.string,
    firstPublishedAt: PropTypes.string.isRequired,
    profileUrl: PropTypes.string.isRequired,
    mediaTypes: PropTypes.arrayOf(PropTypes.string),
    profile: PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      organization: PropTypes.string,
    }).isRequired,
  })).isRequired,
};
